import { getDocument, GlobalWorkerOptions, version } from 'pdfjs-dist';
import { api } from '../api/api';
//GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.js`;
GlobalWorkerOptions.workerSrc = `/js/pdfjs/pdf.worker.min.mjs`;

export function createPdfRenderer(url: string) {

	return new Promise<any>((resolve, reject) => {

		const loadingTask = getDocument(url);
		loadingTask.promise.then(function(pdf: any) {
			resolve(pdf);
		}).catch((e) => {
			reject(e);
		});

	});



	// const loadingTask = getDocument("/bg.pdf");
	// loadingTask.promise.then(function(pdf: any) {
	// 	// you can now use *pdf* here
	// 	var pageNumber = 1;
	// 	pdf.getPage(pageNumber).then(function(page: any) {
	// 	  console.log('Page loaded');
	
	// 	  var scale = 1.5;
	// 	  var viewport = page.getViewport({scale: scale});
	
	// 	  // Prepare canvas using PDF page dimensions
	// 	  var canvas = document.getElementById('pdfOutput') as HTMLCanvasElement;
	// 	  if (!canvas) return;

	// 	  var context = canvas.getContext('2d');
	// 	  canvas.height = viewport.height;
	// 	  canvas.width = viewport.width;
	
	// 	  // Render PDF page into canvas context
	// 	  var renderContext = {
	// 		canvasContext: context,
	// 		viewport: viewport
	// 	  };
	// 	});

	// });

	// function render() {
	// 	var renderTask = page.render(renderContext);
	// 	renderTask.promise.then(function () {
	// 	  console.log('Page rendered');
	// 	});

	// }

	// return {
	// 	pdf,
	// 	numPages: pdf.numPages,
	// }
}


export function PdfViewer(props: {

}) {
	const url = api.getDownloadUrl("126918e1-74e3-4514-91fd-33ae061b3efa");

	const loadingTask = getDocument(url);
	loadingTask.promise.then(function(pdf: any) {
		// you can now use *pdf* here
		var pageNumber = 1;
		pdf.getPage(pageNumber).then(function(page: any) {
		  console.log('Page loaded');
	
		  var scale = 1.5;
		  var viewport = page.getViewport({scale: scale});
	
		  // Prepare canvas using PDF page dimensions
		  var canvas = document.getElementById('pdfOutput') as HTMLCanvasElement;
		  if (!canvas) return;

		  var context = canvas.getContext('2d');
		  canvas.height = viewport.height;
		  canvas.width = viewport.width;
	
		  // Render PDF page into canvas context
		  var renderContext = {
			canvasContext: context,
			viewport: viewport
		  };
		  var renderTask = page.render(renderContext);
		  renderTask.promise.then(function () {
			console.log('Page rendered');
		  });
		});

	});

	return (
		<canvas id="pdfOutput" style={{width:"210mm", height: "297mm"}}></canvas>
	);
}